import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import CommonStructured from "../../components/common-components/CommonStructured";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import { fetchTrainingData } from "../../redux/website-reducers/websiteSlice";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import TrainingForm from "../../components/training/TrainingForm";
import TrainingListings from "../../components/training/TrainingListings";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";

const Training = () => {
  const userInfoData = useSelector(selectUser);
  const dispatch = useDispatch();

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selAssignee: "",
    isActive: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    account_type: allFilters.selAssignee?.value || "",
    status: allFilters.isActive?.value || "",
  };
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [filters, setFilters] = useState(iniFilters);
  const iniModvalues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getTrainingListings(filters) {
    dispatch(
      fetchTrainingData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getTrainingListings(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      account_type: allFilters.selAssignee?.value || "",
      status: allFilters.isActive?.value || "",
    }));
  }, [isPage, pageLimit, allFilters.selAssignee, allFilters.isActive]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Staff Training">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}
        >
          {modValues.modName === "add" || modValues.modName === "edit" ? (
            <TrainingForm
              userInfoData={userInfoData}
              isEdit={modValues.modName === "edit" ? true : false}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              callFunction={() => getTrainingListings(filters)}
            />
          ) : modValues.modName === "description" ? (
            <div className="createNewCTOModalContainer mod-width-50p">
              <ModalHeadAndClose title=" " onClose={onCloseModal} />

              <div className="discussionModalMessage mt15">
                <p
                  className="message"
                  dangerouslySetInnerHTML={{
                    __html:
                      modValues.rowData?.description || "No Content Available",
                  }}
                ></p>
              </div>
            </div>
          ) : null}
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Staff Training"}
              createBtnTxt={"+ Add New URL"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
              isReload={() => getTrainingListings(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from={"training"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <TrainingListings
              userInfoData={userInfoData}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              callFunction={() => getTrainingListings(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default Training;
